import { render, staticRenderFns } from "./assignee.vue?vue&type=template&id=5566badb&scoped=true&"
import script from "./assignee.vue?vue&type=script&lang=js&"
export * from "./assignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566badb",
  null
  
)

export default component.exports